<template>
  <div class="accordion">
    <div class="wrapper">
      <div :class="['accordion-header', { 'opened': isBodyVisible }]">
        <div class="header-left-col-wrapper" @click="handleAccordionHeaderClick">
          <slot name="header-left-col" />
        </div>
        <slot name="header-right-col" />
      </div>
      <div :class="['accordion-body', { 'visible': isBodyVisible }]">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  data() {
    return {
      isBodyVisible: false
    }
  },
  methods: {
    handleAccordionHeaderClick() {
      this.isBodyVisible = !this.isBodyVisible;
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  border-top: 1px solid rgba(#262A30, 0.06);
  padding: 23px 42px 18px 40px;
}

.accordion-body {
  max-height: 0;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
  padding: 0 0 0 12px;
  width: 100%;
  max-width: 80%;

  &.visible {
    max-height: 100vh;
    padding-top: 12px;
  }
}

.header-left-col-wrapper {
  margin: 0 auto 0 0;
  width: 70%;
  cursor: pointer;
}

.accordion-header {
  display: flex;
  align-items: center;
  width: 100%;
}
</style>
